import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * WI 31640 (stored-XSS follow-up to WI 31622): the release-note and announcement
 * popups render admin-authored HTML bodies. They used
 * `domSanitizer.bypassSecurityTrustHtml(...)`, which tells Angular to skip
 * sanitization, so a `<script>`/handler/`javascript:` payload stored in a
 * communication body would execute for every viewer.
 *
 * This routes those bodies through Angular's built-in HTML sanitizer instead
 * (the repo convention, same as the walkthrough driver and the 3147 fix), which
 * strips scripts, inline event handlers, and dangerous URLs while preserving
 * ordinary formatting markup. Shared by both popup components so the trust
 * decision lives in one place with one test.
 *
 * @returns the sanitized HTML string, or an empty string for a null/undefined body.
 */
export function sanitizeCommunicationHtml(
  sanitizer: DomSanitizer,
  value: string | null | undefined
): string {
  return sanitizer.sanitize(SecurityContext.HTML, value ?? '') ?? '';
}
